/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Select, { components } from 'react-select';
import makeAnimated from 'react-select/animated';
import { connect } from 'react-redux';
import { SelectContainer } from './style';
import theme from '../../theme';
import Checkbox from '../Checkbox';
import storage from '../../../app/api/storage';
import Icon from '../Icon';

const Option = (props) => {
  if (props?.isMulti) {
    return (
      <components.Option {...props}>
        <Checkbox checked={props.isSelected} label=" " />
        <div>{props.label}</div>
      </components.Option>
    );
  }
  return (
    <components.Option {...props}>
      <div className={props?.data?.icon ? 'has-icon' : ''}>
        {props?.hasIcon && props?.data?.icon && (
          <div className="wrapper">
            <Icon type={props?.data?.icon} size={20} />
          </div>
        )}
        {props.label}
      </div>
    </components.Option>
  );
};
Option.propTypes = {
  isMulti: PropTypes.bool,
  isSelected: PropTypes.bool,
  data: PropTypes.object,
  label: PropTypes.string,
  hasIcon: PropTypes.bool,
};

const NoOptionsMessage = (props) => (
  <components.NoOptionsMessage {...props}>
    {props.children}
  </components.NoOptionsMessage>
);
NoOptionsMessage.propTypes = {
  children: PropTypes.string,
};

const CustomSelect = ({
  options = [],
  onChange,
  onBlur,
  selected,
  disabled,
  placeholder = 'Seleziona',
  styles = {},
  readonly = false,
  formatOptionLabel,
  className,
  isSearchType = false,
  isClearable = false,
  isMulti = false,
  isSearchable = false,
  hasIcon = false,
  forceNotRendering = false,
  size,
  id,
  maxMenuHeight = 325,
  menuPlacement = 'auto',
  zIndexMenu,
  alwaysEnabled,
  onInputChange = () => { },
  wrapperId,
}) => {
  const customStyles = (themeName) => ({
    option: (provided, state) => ({
      ...provided,
      display: 'flex',
      color: state.isSelected
        ? theme(themeName).colors.textPrimary
        : state.isDisabled
          ? `${theme(themeName).colors.placeholder} !important`
          : theme(themeName).colors.title,
      backgroundColor: state.isSelected
        ? theme(themeName).colors.bgSecondary
        : theme(themeName).colors.bgPrimary,
      paddingLeft: 10,
      paddingRight: 10,
      paddingTop: 10,
      paddingBottom: 10,
      lineHeight: '20px',
      minHeight: 40,
      height: 'auto',
      cursor: 'pointer',
      '&:hover': {
        textDecoration: state.isDisabled ? 'none' : 'underline',
        backgroundColor: theme(themeName).colors.bgSecondary,
      },
      ...styles?.option,
    }),
    control: (provided, state) => {
      return {
        ...provided,
        width: '100%',
        height: 40,
        borderRadius: 4,
        boxShadow: 'none',
        backgroundColor: !state.isDisabled
          ? theme(themeName).colors.bgPrimary
          : theme(themeName).colors.black20,
        cursor: !state.isDisabled ? 'pointer' : 'not-allowed',
        color: state.isDisabled
          ? theme(themeName).colors.radioBtnDisabled
          : state?.isFocused
            ? theme(themeName).colors.focusSelect
            : theme(themeName).colors.title,
        border: `solid 1px ${state.isDisabled
          ? theme(themeName).colors.radioBtnDisabled
          : state?.isFocused
            ? theme(themeName).colors.focusSelect
            : theme(themeName).colors.title
          }`,
        overflow: 'hidden',
        flexDirection: 'row',
        '&:hover': {
          border: `solid 1px ${state?.isFocused
            ? theme(themeName).colors.focusSelect
            : theme(themeName).colors.title
            }`,
          boxShadow: 'none',
        },
        //focus ring
        outline: state?.isFocused ? `2px solid ${theme(themeName).colors.focusRing}` : null,
        outlineOffset: state?.isFocused ? '-2px' : null,
        ...styles?.controls,
      };
    },
    menu: (provided) => ({
      ...provided,
      borderRadius: 4,
      border: `solid 1px ${theme(themeName).colors.border}`,
      boxShadow: 'none',
      marginTop: 10,
      overflow: 'hidden',
      height: 'auto',
      ...styles?.menu,
    }),
    menuList: (provided) => ({
      ...provided,
      paddingTop: 0,
      paddingBottom: 0,
      '::-webkit-scrollbar': {
        width: '4px',
        height: '0px',
      },
      '::-webkit-scrollbar-track': {
        background: '#f1f1f1',
      },
      '::-webkit-scrollbar-thumb': {
        background: '#888',
      },
      '::-webkit-scrollbar-thumb:hover': {
        background: '#555',
      },
      ...styles?.menuList,
    }),
    dropdownIndicator: (provided, state) => ({
      ...provided,
      transform: state.isFocused ? 'rotate(180deg)' : null,
      ...styles?.dropdownIndicator,
      '&:after': {
        left: !state.isFocused ? 0 : 'unset',
        right: !state.isFocused ? 'unset' : 0,
      },
      color: state?.isFocused
        ? theme(themeName).colors.focusSelect
        : theme(themeName).colors.title,
    }),
    indicatorsContainer: (provided, state) => ({
      ...provided,
      ...styles?.indicatorsContainer,
      color: state?.isFocused
        ? theme(themeName).colors.focusSelect
        : theme(themeName).colors.title,
      '&:hover': {
        color: state?.isFocused
          ? theme(themeName).colors.focusSelect
          : theme(themeName).colors.title,
      },
    }),
    indicatorContainer: (provided, state) => ({
      ...provided,
      ...styles?.indicatorContainer,
      color: state.isDisabled
        ? theme(themeName).colors.radioBtnDisabled
        : state?.isFocused
          ? theme(themeName).colors.focusSelect
          : theme(themeName).colors.title,
    }),
    indicatorSeparator: (provided) => ({
      ...provided,
      display: 'none',
      ...styles?.indicatorSeparator,
    }),
    placeholder: (provided, state) => ({
      ...provided,
      color: state.isDisabled
        ? theme(themeName).colors.radioBtnDisabled
        : state?.isFocused
          ? theme(themeName).colors.focusSelect
          : theme(themeName).colors.title,
    }),
  });

  const [selectedOption, setSelectedOption] = useState(selected);

  const onchangeSelected = (value) => {
    setSelectedOption(value);
    if (onChange) onChange(value);
  };

  const handleOnBlur = (e) => {
    e.preventDefault();
    if (onBlur) onBlur(selectedOption);
  };

  useEffect(() => {
    setSelectedOption(selected);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selected]);

  const [searchInput, setSearchInput] = useState('');
  let customProps = {};
  if (isSearchType) {
    customProps = {
      menuIsOpen: searchInput.length >= 3,
      isClearable: true,
    };
  }

  const animatedComponents = makeAnimated();
  const selectComponents = {
    animatedComponents,
    Option,
    NoOptionsMessage,
  };

  return (
    <SelectContainer
      readonly={readonly}
      isSearchType={isSearchType}
      size={size}
      disabled={disabled || !options?.length > 0}
      id={wrapperId}
      zIndexMenu={zIndexMenu}
      as={!id ? 'label' : 'div'}
    >
      {!id && <span className="visually-hidden">{placeholder}</span>}
      <Select
        inputId={id}
        className={className}
        styles={customStyles(storage.read('theme')?.value || '')}
        value={selectedOption}
        onChange={onchangeSelected}
        onBlur={handleOnBlur}
        isDisabled={!alwaysEnabled && (disabled || !options?.length > 0)}
        options={options}
        placeholder={placeholder}
        formatOptionLabel={formatOptionLabel}
        onInputChange={(value) => {
          onInputChange(value);
          setSearchInput(value);
        }}
        isClearable={isClearable}
        isSearchable={isSearchable}
        isMulti={isMulti}
        hasIcon={hasIcon}
        hideSelectedOptions={false}
        controlShouldRenderValue={!forceNotRendering}
        noOptionsMessage={() => 'Nessun risultato'}
        components={{ ...selectComponents }}
        closeMenuOnSelect={!isMulti}
        maxMenuHeight={maxMenuHeight}
        menuPlacement={menuPlacement}
        isOptionDisabled={(option) => option?.isDisabled || false}
        {...customProps}
      />
    </SelectContainer>
  );
};

CustomSelect.propTypes = {
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  options: PropTypes.array,
  selected: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string,
    PropTypes.array,
  ]),
  styles: PropTypes.object,
  customProps: PropTypes.object,
  readonly: PropTypes.bool,
  isSearchType: PropTypes.bool,
  isClearable: PropTypes.bool,
  isMulti: PropTypes.bool,
  isSearchable: PropTypes.bool,
  hasIcon: PropTypes.bool,
  disabled: PropTypes.bool,
  formatOptionLabel: PropTypes.elementType,
  forceNotRendering: PropTypes.bool,
  size: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.oneOf(['s', 'm', 'l', 'full', 'compact']),
  ]),
  id: PropTypes.string,
  maxMenuHeight: PropTypes.number,
  menuPlacement: PropTypes.string,
  zIndexMenu: PropTypes.number,
  alwaysEnabled: PropTypes.bool,
  onInputChange: PropTypes.func,
  wrapperId: PropTypes.string,
};

export default connect((state) => ({}))(CustomSelect);
